import React from "react";

/**
 * CommandsCheatSheet — visual cheat sheet shown when the owner says "what can
 * I ask you" or "list all my commands". Groups every voice command by category.
 */
export default function CommandsCheatSheet({ data }) {
  if (!data?.groups?.length) return null;
  return (
    <div data-testid="commands-cheatsheet">
      <div className="rc-label text-[10px] mb-3 opacity-70">
        {data.total} VOICE COMMANDS · ACROSS {data.groups.length} CATEGORIES · SAY ANY OF THESE
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3 max-h-[72vh] overflow-y-auto pr-1">
        {data.groups.map((g, i) => (
          <div key={i} className="border border-[var(--rc-gold-dim)] p-3 bg-black/30" data-testid={`cmd-group-${i}`}>
            <div className="font-display text-sm rc-glow-text mb-2 tracking-wide">{g.title}</div>
            <div className="space-y-1">
              {g.items.map((item, j) => (
                <div key={j} className="text-[11px] text-[var(--rc-text)] leading-snug border-l-2 border-[var(--rc-gold-dim)] pl-2 py-0.5 hover:border-[var(--rc-gold)] hover:rc-glow-text transition-all">
                  <span className="rc-label text-[9px] opacity-50 mr-1">▸</span>"{item}"
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      <div className="rc-label text-[9px] mt-3 opacity-60 text-center">
        SPEAK NATURALLY — EXACT WORDS NOT REQUIRED · I'LL FIGURE IT OUT
      </div>
    </div>
  );
}
